
export default {
  border_radius_2xs: '--lfds-border-radius-2xs',
  border_radius_xs: '--lfds-border-radius-xs',
  border_radius_sm: '--lfds-border-radius-sm',
  border_radius_md: '--lfds-border-radius-md',
  border_radius_lg: '--lfds-border-radius-lg',
  border_radius_round: '--lfds-border-radius-round',
  border_width_default: '--lfds-border-width-default',
  border_width_emphasis: '--lfds-border-width-emphasis',
  border_width_hover: '--lfds-border-width-hover',
  border_width_focus: '--lfds-border-width-focus',
  border_width_selected: '--lfds-border-width-selected',
  effect_opacity_state_enabled: '--lfds-effect-opacity-state-enabled',
  effect_opacity_state_hover: '--lfds-effect-opacity-state-hover',
  effect_opacity_state_focused: '--lfds-effect-opacity-state-focused',
  effect_opacity_state_pressed: '--lfds-effect-opacity-state-pressed',
  color_border_primary: '--lfds-color-border-primary',
  color_border_secondary: '--lfds-color-border-secondary',
  color_border_tertiary: '--lfds-color-border-tertiary',
  color_border_brand_primary: '--lfds-color-border-brand-primary',
  color_border_brand_secondary: '--lfds-color-border-brand-secondary',
  color_border_focus: '--lfds-color-border-focus',
  color_border_focus_outline: '--lfds-color-border-focus-outline',
  color_border_hover: '--lfds-color-border-hover',
  color_border_pressed: '--lfds-color-border-pressed',
  color_border_error: '--lfds-color-border-error',
  color_border_selected: '--lfds-color-border-selected',
  color_border_selected_secondary: '--lfds-color-border-selected-secondary',
  color_border_disabled: '--lfds-color-border-disabled',
  color_border_on_button_primary: '--lfds-color-border-on-button-primary',
  color_border_on_button_secondary: '--lfds-color-border-on-button-secondary',
  color_border_on_button_tertiary: '--lfds-color-border-on-button-tertiary',
  color_border_on_highlight_primary: '--lfds-color-border-on-highlight-primary',
  color_border_on_highlight_secondary: '--lfds-color-border-on-highlight-secondary',
  color_border_on_highlight_tertiary: '--lfds-color-border-on-highlight-tertiary',
  color_border_on_info: '--lfds-color-border-on-info',
  color_border_on_error: '--lfds-color-border-on-error',
  color_border_on_warning: '--lfds-color-border-on-warning',
  color_border_on_success: '--lfds-color-border-on-success',
  spacing_2xs: '--lfds-spacing-2xs',
  spacing_xs: '--lfds-spacing-xs',
  spacing_sm: '--lfds-spacing-sm',
  spacing_md: '--lfds-spacing-md',
  spacing_lg: '--lfds-spacing-lg',
  spacing_xl: '--lfds-spacing-xl',
  spacing_2xl: '--lfds-spacing-2xl',
  spacing_3xl: '--lfds-spacing-3xl',
  spacing_4xl: '--lfds-spacing-4xl',
  spacing_5xl: '--lfds-spacing-5xl',
  spacing_6xl: '--lfds-spacing-6xl',
  spacing_7xl: '--lfds-spacing-7xl',
  size_control_sm: '--lfds-size-control-sm',
  size_control_default: '--lfds-size-control-default',
  size_control_lg: '--lfds-size-control-lg',
  font_family_display: '--lfds-font-family-display',
  font_family_heading: '--lfds-font-family-heading',
  font_family_body: '--lfds-font-family-body',
  font_family_label: '--lfds-font-family-label',
  font_family_caption: '--lfds-font-family-caption',
  font_family_value: '--lfds-font-family-value',
  font_weight_regular: '--lfds-font-weight-regular',
  font_weight_medium: '--lfds-font-weight-medium',
  font_weight_semibold: '--lfds-font-weight-semibold',
  font_weight_bold: '--lfds-font-weight-bold',
  text_size_display_default: '--lfds-text-size-display-default',
  line_height_display_default: '--lfds-line-height-display-default',
  text_size_heading_level_1: '--lfds-text-size-heading-level-1',
  line_height_heading_level_1: '--lfds-line-height-heading-level-1',
  text_size_heading_level_2: '--lfds-text-size-heading-level-2',
  line_height_heading_level_2: '--lfds-line-height-heading-level-2',
  text_size_heading_level_3: '--lfds-text-size-heading-level-3',
  line_height_heading_level_3: '--lfds-line-height-heading-level-3',
  text_size_heading_level_4: '--lfds-text-size-heading-level-4',
  line_height_heading_level_4: '--lfds-line-height-heading-level-4',
  text_size_heading_level_5: '--lfds-text-size-heading-level-5',
  line_height_heading_level_5: '--lfds-line-height-heading-level-5',
  text_size_heading_level_6: '--lfds-text-size-heading-level-6',
  line_height_heading_level_6: '--lfds-line-height-heading-level-6',
  text_size_body_lg: '--lfds-text-size-body-lg',
  line_height_body_lg: '--lfds-line-height-body-lg',
  text_size_body_default: '--lfds-text-size-body-default',
  line_height_body_default: '--lfds-line-height-body-default',
  text_size_body_sm: '--lfds-text-size-body-sm',
  line_height_body_sm: '--lfds-line-height-body-sm',
  text_size_label_lg: '--lfds-text-size-label-lg',
  line_height_label_lg: '--lfds-line-height-label-lg',
  text_size_label_default: '--lfds-text-size-label-default',
  line_height_label_default: '--lfds-line-height-label-default',
  text_size_label_sm: '--lfds-text-size-label-sm',
  line_height_label_sm: '--lfds-line-height-label-sm',
  text_size_caption_default: '--lfds-text-size-caption-default',
  line_height_caption_default: '--lfds-line-height-caption-default',
  text_size_value_2xl: '--lfds-text-size-value-2xl',
  line_height_value_2xl: '--lfds-line-height-value-2xl',
  text_size_value_xl: '--lfds-text-size-value-xl',
  line_height_value_xl: '--lfds-line-height-value-xl',
  text_size_value_lg: '--lfds-text-size-value-lg',
  line_height_value_lg: '--lfds-line-height-value-lg',
  text_size_value_md: '--lfds-text-size-value-md',
  line_height_value_md: '--lfds-line-height-value-md',
  text_size_value_sm: '--lfds-text-size-value-sm',
  line_height_value_sm: '--lfds-line-height-value-sm',
  color_animation_primary: '--lfds-color-animation-primary',
  color_animation_secondary: '--lfds-color-animation-secondary',
  color_background_primary: '--lfds-color-background-primary',
  color_background_secondary: '--lfds-color-background-secondary',
  color_background_tertiary: '--lfds-color-background-tertiary',
  color_background_brand_primary: '--lfds-color-background-brand-primary',
  color_background_brand_secondary: '--lfds-color-background-brand-secondary',
  color_background_selected: '--lfds-color-background-selected',
  color_background_disabled: '--lfds-color-background-disabled',
  color_background_highlight_primary: '--lfds-color-background-highlight-primary',
  color_background_highlight_secondary: '--lfds-color-background-highlight-secondary',
  color_background_highlight_tertiary: '--lfds-color-background-highlight-tertiary',
  color_background_info: '--lfds-color-background-info',
  color_background_success: '--lfds-color-background-success',
  color_background_warning: '--lfds-color-background-warning',
  color_background_error: '--lfds-color-background-error',
  color_background_button_primary: '--lfds-color-background-button-primary',
  color_background_button_primary_pressed: '--lfds-color-background-button-primary-pressed',
  color_background_button_secondary: '--lfds-color-background-button-secondary',
  color_background_button_secondary_pressed: '--lfds-color-background-button-secondary-pressed',
  color_background_button_tertiary: '--lfds-color-background-button-tertiary',
  color_background_button_tertiary_pressed: '--lfds-color-background-button-tertiary-pressed',
  color_background_button_quaternary: '--lfds-color-background-button-quaternary',
  color_background_button_quaternary_pressed: '--lfds-color-background-button-quaternary-pressed',
  color_background_notification_primary: '--lfds-color-background-notification-primary',
  color_background_notification_secondary: '--lfds-color-background-notification-secondary',
  color_background_notification_tertiary: '--lfds-color-background-notification-tertiary',
  color_background_transparent_primary: '--lfds-color-background-transparent-primary',
  color_background_transparent_secondary: '--lfds-color-background-transparent-secondary',
  color_background_skeleton_primary: '--lfds-color-background-skeleton-primary',
  color_background_skeleton_secondary: '--lfds-color-background-skeleton-secondary',
  color_icon_primary: '--lfds-color-icon-primary',
  color_icon_secondary: '--lfds-color-icon-secondary',
  color_icon_tertiary: '--lfds-color-icon-tertiary',
  color_icon_inverted: '--lfds-color-icon-inverted',
  color_icon_selected: '--lfds-color-icon-selected',
  color_icon_hovered: '--lfds-color-icon-hovered',
  color_icon_focused: '--lfds-color-icon-focused',
  color_icon_pressed: '--lfds-color-icon-pressed',
  color_icon_disabled: '--lfds-color-icon-disabled',
  color_icon_error: '--lfds-color-icon-error',
  color_icon_on_button_primary: '--lfds-color-icon-on-button-primary',
  color_icon_on_button_secondary: '--lfds-color-icon-on-button-secondary',
  color_icon_on_button_tertiary: '--lfds-color-icon-on-button-tertiary',
  color_icon_on_info: '--lfds-color-icon-on-info',
  color_icon_on_error: '--lfds-color-icon-on-error',
  color_icon_on_warning: '--lfds-color-icon-on-warning',
  color_icon_on_success: '--lfds-color-icon-on-success',
  color_illustration_base_primary: '--lfds-color-illustration-base-primary',
  color_illustration_accent_primary: '--lfds-color-illustration-accent-primary',
  color_illustration_base_secondary: '--lfds-color-illustration-base-secondary',
  color_illustration_accent_secondary: '--lfds-color-illustration-accent-secondary',
  color_illustration_base_tertiary: '--lfds-color-illustration-base-tertiary',
  color_illustration_accent_tertiary: '--lfds-color-illustration-accent-tertiary',
  color_text_primary: '--lfds-color-text-primary',
  color_text_secondary: '--lfds-color-text-secondary',
  color_text_brand_primary: '--lfds-color-text-brand-primary',
  color_text_brand_secondary: '--lfds-color-text-brand-secondary',
  color_text_link: '--lfds-color-text-link',
  color_text_link_hover: '--lfds-color-text-link-hover',
  color_text_link_focus: '--lfds-color-text-link-focus',
  color_text_link_pressed: '--lfds-color-text-link-pressed',
  color_text_positive: '--lfds-color-text-positive',
  color_text_negative: '--lfds-color-text-negative',
  color_text_error: '--lfds-color-text-error',
  color_text_inverted: '--lfds-color-text-inverted',
  color_text_selected: '--lfds-color-text-selected',
  color_text_disabled: '--lfds-color-text-disabled',
  color_text_on_button_primary: '--lfds-color-text-on-button-primary',
  color_text_on_button_secondary: '--lfds-color-text-on-button-secondary',
  color_text_on_button_tertiary: '--lfds-color-text-on-button-tertiary',
  color_text_on_button_quaternary: '--lfds-color-text-on-button-quaternary',
  color_text_on_img: '--lfds-color-text-on-img',
  color_text_on_risk: '--lfds-color-text-on-risk',
  color_legends_one_100: '--lfds-color-legends-one-100',
  color_legends_one_200: '--lfds-color-legends-one-200',
  color_legends_one_300: '--lfds-color-legends-one-300',
  color_legends_one_400: '--lfds-color-legends-one-400',
  color_legends_one_500: '--lfds-color-legends-one-500',
  color_legends_one_600: '--lfds-color-legends-one-600',
  color_legends_two_100: '--lfds-color-legends-two-100',
  color_legends_two_200: '--lfds-color-legends-two-200',
  color_legends_two_300: '--lfds-color-legends-two-300',
  color_legends_two_400: '--lfds-color-legends-two-400',
  color_legends_two_500: '--lfds-color-legends-two-500',
  color_legends_two_600: '--lfds-color-legends-two-600',
  color_legends_three_100: '--lfds-color-legends-three-100',
  color_legends_three_200: '--lfds-color-legends-three-200',
  color_legends_three_300: '--lfds-color-legends-three-300',
  color_legends_four_100: '--lfds-color-legends-four-100',
  color_risk_risk_default: '--lfds-color-risk-risk-default',
  color_risk_risk_01: '--lfds-color-risk-risk-01',
  color_risk_risk_02: '--lfds-color-risk-risk-02',
  color_risk_risk_03: '--lfds-color-risk-risk-03',
  color_risk_risk_04: '--lfds-color-risk-risk-04',
  color_risk_risk_05: '--lfds-color-risk-risk-05',
  color_risk_risk_06: '--lfds-color-risk-risk-06',
  color_risk_risk_07: '--lfds-color-risk-risk-07',
  color_state_layer_on_dark: '--lfds-color-state-layer-on-dark',
  color_state_layer_on_light: '--lfds-color-state-layer-on-light',
  component_toggle_color_background_on: '--lfds-component-toggle-color-background-on',
  component_alert_color_on_info: '--lfds-component-alert-color-on-info',
  component_alert_color_on_warning: '--lfds-component-alert-color-on-warning',
  component_alert_color_on_error: '--lfds-component-alert-color-on-error',
  component_alert_color_on_success: '--lfds-component-alert-color-on-success',
  component_icon_button_color_background: '--lfds-component-icon-button-color-background'
}